import React from 'react';
import '../App.css';
import { Button } from './Button';
import './HeroSectionProducts.css';

function HeroSectionProducts() {
  return (
    <div className='hero-container'>
      <video src='/videos/products.mp4' autoPlay loop muted />
      <h1>TRY OUR 3D MODELS</h1>
      <p>Go,go,go...</p>
      <div className='hero-btns'>
        
        
      </div>
    </div>
  );
}

export default HeroSectionProducts;